import { TUniversity } from "../../types";
import { FC } from "react";
import ViewUniversityHeader from "./view-university-header";
import BasicInformation from "./basic-information";
import AddressInformation from "./address-information";
import ContactInformation from "./contact-information";
import UniversityCustomFields from "./university-custom-fields";

const ViewUniversityModal: FC<{ university: TUniversity }> = ({ university }) => {
    return (
        <>
            <ViewUniversityHeader university={university} />
            <div className="space-y-4 overflow-y-auto scrollbar-gray max-h-[77vh]">
                <BasicInformation university={university} />
                <AddressInformation university={university} />
                <ContactInformation university={university} />
                <UniversityCustomFields university={university} />
            </div>
        </>
    )
}

export default ViewUniversityModal